import React, { FC } from 'react';
import { connect } from 'react-redux';
import { compose } from '@reduxjs/toolkit';

import type { BettingContextProps } from '../../../../../../types';
import type { MatchInformationComponentsProps } from '../../types';
import type { ReduxState } from 'app/redux/types';

import { withinBettingContext } from 'app/contexts/betting';
import type { RecordOfMatchEntity } from 'app/lib/betting/betting-entities';
import { SportId } from 'app/lib/betting/constants';
import { ESportsPeriods } from 'app/lib/periods';
import { ESportsKeyPeriod } from 'app/lib/periods/ESports/constants';

import { MatchPeriodLabel } from '../../../MatchPeriodLabel';
import { MatchTimePeriod } from '../MatchTimePeriod';

type StoreProps = {
  periods?: RecordOfMatchEntity['periods'];
  sportId?: SportId;
  hasTimer?: boolean;
};

const CounterStrikeInformation: FC<MatchInformationComponentsProps & StoreProps> = ({
  matchId,
  hasTimer,
  periods,
  sportId,
}) => {
  const { key, value } = ESportsPeriods(sportId, periods);

  if (hasTimer && key === ESportsKeyPeriod.PERIOD) {
    return (
      <MatchTimePeriod matchId={matchId}
                       periodValue={value} />
    );
  }

  return (
    <MatchPeriodLabel>
      {value}
    </MatchPeriodLabel>
  );
};

// --

const mapStateToProps = (
  state: ReduxState,
  {
    $betting: {
      content: {
        selectors: { matches },
      },
    },
    matchId,
  }: BettingContextProps,
) => {
  const match = matches(state).get(matchId);

  return {
    periods: match?.periods,
    sportId: match?.sportId,
    hasTimer: Boolean(match.timer),
  };
};

export default compose<FC<MatchInformationComponentsProps>>(
  withinBettingContext,
  connect(mapStateToProps),
)(CounterStrikeInformation);
